import React from 'react'
import PropTypes from 'prop-types'

import {
  StyledH4
} from './styles/H4.styles'

const H4 = ({ children, ...props }) => (
  <StyledH4
    as='h4'
    {...props}
  >
    {children}
  </StyledH4>
)

H4.propTypes = {
  children: PropTypes.node.isRequired
}

H4.defaultProps = {
  fontSize: [33.6]
}

export default H4
